/**
 * Used for identifying modules.
 *
 * @internal
 */
export const MODULE: unique symbol = Symbol.for("Alepha.Module");
